import notificationsType from "../types/notifications-type";
import { config } from "../../config/config";
import endpoints from '../../endpoints/endpoints';
import { METRIC_INFO } from "../../constants";
import constants from "../../constants";


export const createNotification = (values: any,
                                   onSuccess: ((data: any) => void) | null = null,
                                   onError: ((error: any) => void) | null = null
) => ({
    type: notificationsType.CREATE_NOTIFICATION,
    onResponse: (response) => {
        if (response.loadingStatus === constants.LOADING_SUCCESS) {
            if (onSuccess) {
                onSuccess(response.data);
            }
        } else {
            if (onError) {
                onError(response.data);
            }
        }
    },
    http: {
        cognito: {
            effect: {
                url: config.BASE_NOTIFICATIONS_URL + endpoints.notificationsEndpoint(),
                method: "POST",
                json: values
            },
            commit: {
                type: notificationsType.CREATE_NOTIFICATION_COMMIT,
                log: {
                    feature: METRIC_INFO.NOTIFICATION
                }
            },
            rollback: {
                type: notificationsType.CREATE_NOTIFICATION_ROLLBACK,
                log: {
                    feature: METRIC_INFO.NOTIFICATION
                }
            }
        }
    }
});
